import React, { useEffect, useState } from 'react';
import CourseAddStep3HoleAndAtBatContainer from './CourseAddStep3HoleAndAtBatContainer'

function CourseAddStep3CourseContainer(props) {
    const [courseName, setCourseName] = useState(props.nowCourse.courseName);
    const [holeAndAtBatList, setHoleAndAtBatList] = useState(props.nowCourse.holeList);

    useEffect(() => {

    }, []);
    return (
        <div className="c-container-horizontal">    {/*<!-- コース名コンテナ -->*/}
            {/* <!-- コース名内容 -->*/}
            <div className="game-data__column">
                <span className="game-data__slot">{courseName}</span>
            </div>

            {/*<!-- コース名の子要素 -->*/}
            <div className="c-container-vertical">

                {/*ここに ホール名」と「規定打数」コンテナをホール数ループ*/}
                {/*動的にコンポーネントが増えていきます*/}
                {holeAndAtBatList.map(holeAndAtBatItem => (
                    <CourseAddStep3HoleAndAtBatContainer
                        key={courseName + "_" + holeAndAtBatItem.name}
                        nowHoleAndAtBatData={holeAndAtBatItem}
                    />
                ))}


            </div>{/*<!-- コース名の子要素 -->*/}
         {/*<!-- コース名コンテナ -->*/ }
        </div>
    )
}


export default CourseAddStep3CourseContainer

